<template>
	<div class="commitment-assignees">
		<div v-for="m in members"
			:key="m.personId"
			class="commitment-assignees-item"
			@click="$emit( `select`, m )"
		>
			<div class="commitment-assignees__avatar">
				<UserAvatar
					:user="m"
				/>
			</div>
			<div class="commitment-assignees__name">{{ m.displayName }}</div>
		</div>
		<div v-if="showUnassign && selectedMemberId"
			class="commitment-assignees-item"
			@click="$emit( `select`, null )"
		>
			<div class="commitment-assignees__avatar">
				<FontAwesomeIcon
					class="commitment-assignees__unassign-icon"
					:icon="['fas', 'user']"
				/>
			</div>
			<div class="commitment-assignees__name">{{ $t( "common.CommitmentAssignees_unassignItem" ) }}</div>
		</div>
	</div>
</template>

<script>
import UserAvatar from "../UserAvatar";

export default {
	name: "CommitmentAssignees",
	emits: [ "select", ],
	components: {
		UserAvatar,
	},
	props: {
		members: {
			type: Array,
			required: true,
		},
		selectedMemberId: {
			type: String,
			default: "",
		},
		showUnassign: {
			type: Boolean,
			default: true,
		},
	},
	computed: {},
	methods: {},
};
</script>

<style lang="scss" scoped>
.commitment-assignees {
	width: 14rem;
	z-index: 10;
	background-color: white;
	border: 0.0625rem solid $commitment-assignees-menu-border-color;
	box-shadow: 0 0.1875rem 0.375rem 0.0625rem rgba(33, 45, 99, 0.1), 0 1.3125rem 1.875rem -1.25rem rgba(33, 45, 99, 0.2);
	border-radius: 0.5rem;
	padding: 0.5rem;
	margin-top: 0.4rem;
}

.commitment-assignees__unassign-icon {
	cursor: pointer;
	height: 1.5rem;
	width: 1.5rem;
	color: $commitment-assignees-unassign-icon-color;
}

.commitment-assignees-item {
	cursor: pointer;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	flex-wrap: nowrap;
	align-content: center;
	padding: 0.5rem;
	border-radius: 0.5rem;
	color: $commitment-assignees-font-color;
	gap: 1rem;
	&:hover {
		background-color: $commitment-assignees-background-color--hover;
		color: $commitment-assignees-font-color--hover;
	}
}

.commitment-assignees__name {
	height: 100%;
	@include font-and-line-for(0);
	// forcing a different line height here to vertically align
	line-height: 1.5rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
